import { createSlice } from '@reduxjs/toolkit'

const BlogSlice = createSlice({
    name: "Blog",
    initialState: {
        blogs: [],
        currentBlog: {
            title: '',
            content: '',
            banner: '',
            author: '',
            publishDate: '',
            isDraft: true
        },
        isLoading: false,
        error: null,
        isSaving: false
    },
    reducers: {
        // Create/Save blog actions
        saveBlogStart: (state) => {
            state.isSaving = true
        },
        saveBlogSuccess: (state, action) => {
            state.isSaving = false
            state.currentBlog = action.payload
            state.error = null
        },
        saveBlogFailure: (state, action) => {
            state.isSaving = false
            state.error = action.payload
        },

        // Fetch blogs actions
        fetchBlogsStart: (state) => {
            state.isLoading = true
        },
        fetchBlogsSuccess: (state, action) => {
            state.isLoading = false
            state.blogs = action.payload
            state.error = null
        },
        fetchBlogsFailure: (state, action) => {
            state.isLoading = false
            state.error = action.payload
        },

        // Update current blog
        updateCurrentBlog: (state, action) => {
            state.currentBlog = {
                ...state.currentBlog,
                ...action.payload
            }
        },

        // Clear current blog
        clearCurrentBlog: (state) => {
            state.currentBlog = {
                title: '',
                content: '',
                banner: '',
                author: '',
                publishDate: '',
                isDraft: true
            }
        }
    }
})

export const {
    saveBlogStart,
    saveBlogSuccess,
    saveBlogFailure,
    fetchBlogsStart,
    fetchBlogsSuccess,
    fetchBlogsFailure,
    updateCurrentBlog,
    clearCurrentBlog
} = BlogSlice.actions

export default BlogSlice.reducer